import { AlmanacFileSummary, AlmanacFile as File } from 'types'
import { Assignee, AssigneeType } from 'api/clients/PropertyClient'
import {
  ARTICLE_REVIEW_PATH,
  ARTICLE_NEW_REVIEW_PATH,
  ARTICLE_SUBMIT_REVIEW_PATH,
  ARTICLE_CANCEL_REVIEW_PATH,
  ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH,
  ARTICLE_ENDED_REVIEW_PATH,
  DOC_ACTIVITY_PATH,
  DOC_ACTIVITY_BRANCH_PATH,
  DOC_INSIGHTS_PATH,
  DOC_COMPARE_PATH,
  DOC_PATH,
  HANDBOOK_PATH,
  FOLDER_PATH,
} from 'paths'
import { TreeFile } from './FinderContextTypes'
import { getLocation } from 'hooks/useHistory'

export const filterSelectedFiles = ({
  files,
  currentFile,
  lastCheckedIndex,
  selectedFiles,
}: {
  files: File[]
  currentFile: File
  lastCheckedIndex: number
  selectedFiles: File[]
}) => {
  const currentIndex = files.indexOf(currentFile)
  const currentIndexLower = currentIndex < lastCheckedIndex
  const range = currentIndexLower ? [currentIndex, lastCheckedIndex] : [lastCheckedIndex + 1, currentIndex + 1]
  const shiftSelectedFiles = files.slice(...range)
  const allIds = shiftSelectedFiles.map((f) => f.id)
  return shiftSelectedFiles.filter(
    (f: File) => !allIds.includes(f.parent_id || '') && !selectedFiles.some((selected) => selected.id === f.id),
  )
}

export const fileToAssignee = ({ id, type }: File | TreeFile | AlmanacFileSummary) => {
  let assignee_type = AssigneeType.Article
  if (type === 'folder') {
    assignee_type = AssigneeType.Project
  }

  if (type === 'media_file') {
    assignee_type = AssigneeType.MediaFile
  }

  if (type === 'design') {
    assignee_type = AssigneeType.Design
  }

  return {
    id,
    type: assignee_type,
  } as Assignee
}

export const isFileTheCurrentLocation = ({ id, slug }: File) => {
  return currentlyInFile(id) || currentlyInFile(slug)
}

export const currentlyInFile = (slug?: string) => {
  if (slug == null) return false
  return [
    ARTICLE_REVIEW_PATH,
    ARTICLE_NEW_REVIEW_PATH,
    ARTICLE_SUBMIT_REVIEW_PATH,
    ARTICLE_CANCEL_REVIEW_PATH,
    ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH,
    ARTICLE_ENDED_REVIEW_PATH,
    DOC_ACTIVITY_PATH,
    DOC_ACTIVITY_BRANCH_PATH,
    DOC_INSIGHTS_PATH,
    DOC_COMPARE_PATH,
    DOC_PATH,
    HANDBOOK_PATH,
    FOLDER_PATH,
  ].some((path) => getLocation().pathname.startsWith(path.replace(/:slug/, slug)))
}

export const DEFAULT_LOCATIONS = ['root', 'recent']
